import { render, staticRenderFns } from "./comp_ProductCard-VariantSelector.vue?vue&type=template&id=3b96bb8b&scoped=true&"
import script from "./comp_ProductCard-VariantSelector.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCard-VariantSelector.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCard-VariantSelector.vue?vue&type=style&index=0&id=3b96bb8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96bb8b",
  null
  
)

export default component.exports